
function getDepth(el) {
  let depth = 0;
  while (el) {
    el = el.parentElement;
    depth++;
  }
  return depth;
}

const state = {
        itemGroups: [
        ], // Context Menu Items
    }
    const mutations= {
        addItems(state, {payload }) {
            state.itemGroups.push(payload);
        },
        clearItems(state) {
            state.itemGroups = [];
        }
    }
    const actions= {
        addContextMenuItems({ commit }, {items, priority, $event}) {
            let depth = 0;
            if ($event) depth = getDepth($event.currentTarget);
            // const stack = new Error().stack;
            // const callerLine = stack.split('\n')[3]; // [0] = "Error", [1] = this function, [2] = caller
            // console.log('addContextMenuItems called from:', callerLine.trim());
            // console.log('EVENT', $event);
            commit('addItems', {payload: { items, priority, depth }});
        },
        clearContextMenu({ commit }) {
            commit('clearItems');
        },
    }
    const getters= {
        getContextMenuItems: (state) => {
            // return state.itemGroups.sort((a, b) => (a.priority || 0) - (b.priority || 0));
            return state.itemGroups.sort((a, b) =>  - (a.depth) + (b.depth));
        },
    }
    
    export default {
        state,
        mutations,
        actions,
        getters,
    }
    

    // Usage in a component
// <template @contextmenu="this.$store.dispatch('contextmenu/addContextMenuItems', [
//         [
//                 { label: 'Test', action: () => { console.log('Test') } },
//
//         ]
// ])">